import { render, staticRenderFns } from "./TabelaPedidos.vue?vue&type=template&id=0c53f902&"
import script from "./TabelaPedidos.vue?vue&type=script&lang=js&"
export * from "./TabelaPedidos.vue?vue&type=script&lang=js&"
import style0 from "./TabelaPedidos.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports